import React, { useEffect, useState } from "react";
import "./Home_SectionThree.scss";
import { getMightLike } from "../../../services/home/home";
import { Link } from "react-router-dom";

function Home_SectionThree() {
  const [mightLike, setMightLike] = useState([]);

  useEffect(() => {
    const fetchApi = async () => {
      const contentMightLike = await getMightLike();
      setMightLike(contentMightLike);
      //   console.log(contentMightLike);
    };
    fetchApi();
  }, []);

  return (
    <>
      <div className="home-sectionThree">
        <div className="container">
          <div className="home-sectionThree-wrapper">
            {mightLike.length > 0 && (
              <React.Fragment>
                <div className="box-head">Bạn có thể thích</div>

                <div className="might-like">
                  {mightLike.map((item) => (
                    <Link
                      to="/products"
                      className="might-like-item"
                      key={item.id}
                    >
                      {item.title}
                    </Link>
                  ))}
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Home_SectionThree;
